import { DWOLLA_ACTION_TYPES } from "../actions/dwolla.actions";

const initialState = {
   terminalsInfo: [],
   terminalInfo: {},
   isLoading: false,
};

const dwollaReducer = (state = initialState, action) => {
   switch (action.type) {
      case DWOLLA_ACTION_TYPES.GET_USER_DWOLLA_INFO:
         return {
            ...state,
            isLoading: true,
         };
      case DWOLLA_ACTION_TYPES.GET_USER_DWOLLA_INFO_DONE:
         return {
            ...state,
            terminalsInfo: action.payload,
            isLoading: false,
         };

      default:
         return state;
   }
}

export default dwollaReducer;
